import PropTypes from 'prop-types'
import { Button, Typography, Box } from '@mui/material'

import { ReactComponent as ArrowLeft } from '../../../assets/icons/arrow-left.svg'
import useStyles from './styles'

const EmptyState = ({ title, subtitle, buttonText, onClick }) => {
  const classes = useStyles()
  return (
    <Box className={classes.emptyState}>
      <Typography variant="h2" className="decorator">
        {title}
      </Typography>
      {Boolean(subtitle) && (
        <Typography sx={{ color: 'neutral.main' }}>{subtitle}</Typography>
      )}
      <Button onClick={onClick} startIcon={<ArrowLeft />}>
        {buttonText}
      </Button>
    </Box>
  )
}

EmptyState.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  buttonText: PropTypes.string,
  onClick: PropTypes.func,
}

export default EmptyState
